import { Component } from '@angular/core';
import AppValues from 'src/app/common/app.values';
import { NotificationType } from '../component-type.enum';
import { NotificationContext } from '../notification.context';

@Component({
  selector: 'app-conversational-notification',
  templateUrl: './conversational-notification.component.html',
  styleUrls: ['./conversational-notification.component.scss'],
})
export class ConversationalNotificationComponent extends NotificationContext {
  public readonly DATE_TIME_FORMAT_SHORT: string = AppValues.DATE_TIME_FORMAT_SHORT;
  public readonly notificationType: NotificationType = NotificationType.Conversational;
}
